export default __webpack_public_path__ + "static/media/img_si_con_01.e907f6aa.png";